import React, { useState, useEffect, useRef } from 'react';
import './FibreDealsSearch.css';

import LocationIcon from '../../Common/Svg/LocationIcon';
import {
  getAutoCompleteForAddress
} from '../../../Services/Services';
import SearchClearIcon from "../../Common/Svg/SearchClearIcon";
import {
  tagOnCampaignCoverageSearch,
} from "./../../../Tagging/SalesCampaignTagging";

const FibreDealsSearch = ({value, inputIdentifier, updateValue, onAddressSelection, automationidattr, resetCoverageState}) => {
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);

  const [autoCompleteTimeout, setAutoCompleteTimeout] = useState(null);
  const [addressAutoCompletes, setAddressAutoCompletes] = useState([]);
  const [showNoResultFound, setShowNoResultFound] = useState(false);
  const [clicked, setClicked] = useState(false);

  const searchStringChangeHandler = event => {

    if (event.target.value.length === 1) {
      tagOnCampaignCoverageSearch();
    }

    setClicked(false)
    const searchString = event.target.value;
    updateValue(searchString, inputIdentifier)
    if (searchString.trim() === "" || searchString.length < 4) {
      return setAddressAutoCompletes([]);
    }
    if (autoCompleteTimeout !== null) {
      clearTimeout(autoCompleteTimeout);
    }
    const timeOut = setTimeout(() => getAutoComplete(searchString), 400);
    setAutoCompleteTimeout(timeOut);
  }

  const getAutoComplete = searchString => {
    getAutoCompleteForAddress(searchString)
      .then(response => {
        if (response && response.result && response.result.predictions) {
          setAddressAutoCompletes(response.result.predictions);
          if(response.result.length > 0) {
            setShowNoResultFound(false);
            if (clicked) {
              setShowNoResultFound(false);
              setAddressAutoCompletes([]);
            }
          }else{
            setShowNoResultFound(true);
            if (clicked) {
              setShowNoResultFound(false);
              setAddressAutoCompletes([])
            }
          }
        }
      }).catch(error => {
        console.dir(error);
      });
  }

  const clearSearchField = () => {
    updateValue("", inputIdentifier);
    setAddressAutoCompletes([]);
  }

  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setAddressAutoCompletes([]);
          setShowNoResultFound(false);
        }
      }

      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  return(
    <div
      className="mmr2-searchbar-container"
      ref={wrapperRef}
    >
      <div className={`vetting-search-bar-wrapper ${((addressAutoCompletes.length > 0 || showNoResultFound) && !clicked) ? 'newBorderRadius' : ''}`}>
      <div className="location-icon">
        <LocationIcon/>
      </div>
        <input
          type="text"
          className="vetting-search-text"
          placeholder="Type your address here"
          value={value}
          onChange={(e) => searchStringChangeHandler(e)}
          automationid={`SalesLead_input_${automationidattr}searchInput_1`}
        />
       { (value.length > 0) &&
          <div className="search-icon"
            onClick = {()=> {clearSearchField(); resetCoverageState(); setShowNoResultFound(false)}}
            style={{cursor: "pointer"}}>
            <SearchClearIcon/>
          </div>
       }

        {
          !clicked ?
          addressAutoCompletes && addressAutoCompletes.length > 0 ?
            <ul className="search-result__list-container">
              {
                addressAutoCompletes.map((item, index) => {
                  return (
                    <li
                      onClick={() => { onAddressSelection(item.description); setClicked(true) }}
                      key={index}
                      automationid={`SalesLead_li_${automationidattr}ListItem_${index}`}
                    >
                      {item.description}
                    </li>
                  )
                })
              }
            </ul>
            :
            showNoResultFound ?
              <ul className="search-result__list-container">
                <li
                  key={"no-search-result"}
                  automationid={`SalesLead_li_ListItemNOResult_0`}
                >
                  No results found
                </li>
              </ul>
              :
              null
              :
              null
        }
      </div>
    </div>
  )
}

export default FibreDealsSearch;